import { t } from 'i18next';
import React from 'react'

const getStatusStyle = (status) => {
    switch (status?.toUpperCase()) {
        case 'PENDING':
            return { backgroundColor: '#FFEDD5', color: '#C2410C' };
        case 'PREPARING':
            return { backgroundColor: '#FED7AA', color: '#9A3412' };
        case 'ON_THE_WAY':
            return { backgroundColor: '#DBEAFE', color: '#1D4ED8' };
        case 'COMPLETE':
            return { backgroundColor: '#DCFCE7', color: '#15803D' };
        case 'CANCELED':
        case 'CANCELLED':
            return { backgroundColor: '#FEE2E2', color: '#DC2626' };
        case 'REJECTED':
            return { backgroundColor: '#FCE7F3', color: '#BE185D' };
        case 'SCHEDULED':
            return { backgroundColor: '#FEF3C7', color: '#CA8A04' };
        default:
            return { backgroundColor: '#E5E7EB', color: '#374151' };
    }
};
const OrderStatusTag = ({status}) => {
    return (
        <span
            className={`inline-block mt-2 px-3 py-1 text-xs font-medium rounded-full w-fit min-w-20 capitalize text-center`}
            style={getStatusStyle(status)}
        >
            {t(status?.replaceAll("_", " ")?.toLowerCase())}
        </span>
    )
}

export default OrderStatusTag